import { render, staticRenderFns } from "./CopyModal.vue?vue&type=template&id=27ae356c&scoped=true"
import script from "./CopyModal.vue?vue&type=script&lang=js"
export * from "./CopyModal.vue?vue&type=script&lang=js"
import style0 from "./CopyModal.vue?vue&type=style&index=0&id=27ae356c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae356c",
  null
  
)

export default component.exports